import { TECHNOLOGIES } from "@/lib/site";

export const Technologies = () => (
  <section id="technologies" className="py-24 lg:py-32" data-testid="technologies-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-12">
      <div className="text-center max-w-3xl mx-auto">
        <div className="text-xs uppercase tracking-[0.2em] font-semibold text-brand-purple">Our stack</div>
        <h2 className="section-heading text-3xl sm:text-4xl lg:text-5xl mt-3 text-slate-900">
          Modern <span className="text-gradient">technologies</span> we love
        </h2>
        <p className="mt-4 text-slate-600 max-w-xl mx-auto">
          A carefully curated toolchain — battle-tested across hundreds of production deployments.
        </p>
      </div>

      <div className="mt-14 marquee mask-fade">
        <div className="marquee-track">
          {[...TECHNOLOGIES, ...TECHNOLOGIES].map((t, i) => (
            <div
              key={t + i}
              className="shrink-0 min-w-[180px] h-24 rounded-2xl bg-white border border-slate-100 soft-shadow flex items-center justify-center"
              data-testid={`tech-item-${t.toLowerCase().replace(/[^a-z0-9]/g, "-")}-${i}`}
            >
              <div className="font-heading font-extrabold text-xl text-slate-800">
                {t}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
